export const SEARCH = {
    OPTIONS: {
        TAG_AND_FILE_TITLE: 'searchByTagAndFileTitle'
    }
};
